export default "/assets/images/mila-feed-15.mp4?97e6bd9e11f39ede0b7cb586738561ad";